import React from 'react'
import ProductPage from './ProductPage'

const ACCENT = '#10b981'
const ACCENT_2 = '#34d399'

export const veyroData = {
  slug: 'veyro',
  accent: ACCENT,
  accent2: ACCENT_2,

  seo: {
    title: "Veyro — Un'app, ogni trainer",
    description: "Veyro è il marketplace mobile di personal training che unisce allenamento, nutrizione e coaching in un'unica app. In beta test su iOS e Android.",
    canonical: '/veyro',
    schema: {
      name: 'Veyro',
      description: 'Marketplace mobile di personal training: schede di allenamento, piani alimentari e coaching con personal trainer verificati.',
      url: 'https://vmdproject.com/veyro',
      operatingSystem: 'iOS, Android',
      applicationCategory: 'HealthApplication',
    },
  },

  eyebrow: '// veyro',
  badge: 'Beta test — TestFlight / Play Internal',

  hero: {
    titleLead: "Un'app,",
    titleAccent: 'ogni trainer.',
    intro: 'Marketplace mobile di personal training: trova un coach verificato, segui le sue schede, costruisci i tuoi piani alimentari e traccia i progressi. Tutto in un unico posto.',
    image: '/images/veyro/home.webp',
    imageAlt: 'Veyro — home dell\'app con la scheda del giorno, continuità settimanale e progressi',
    imageWidth: 640,
    imageHeight: 1391,
    ctaTo: '/collabora',
    ctaLabel: 'Richiedi accesso alla beta',
  },

  links: { privacy: '/veyro/policy', terms: '/veyro/terms' },

  related: {
    to: '/veyro-trainer',
    label: 'Sei un personal trainer? Scopri Veyro Trainer',
    footerLabel: 'Veyro Trainer',
  },

  about: {
    eyebrow: "// cos'è veyro",
    title: 'Allenamento, nutrizione e coach nella stessa app.',
    text: [
      "Veyro è un'app mobile per iOS e Android che unisce schede di allenamento, piani alimentari e un marketplace di personal trainer verificati. Chi si allena può seguire la scheda di un coach oppure costruirne una propria da una libreria di oltre 800 esercizi.",
      "I trainer vendono piani singoli o coaching mensile direttamente nell'app: il pagamento viene diviso in automatico con Stripe Connect e al trainer arriva sempre l'85%.",
    ],
  },

  gallery: {
    eyebrow: "// dentro l'app",
    title: "L'app, schermata per schermata.",
    banner: {
      src: '/images/veyro/banner.webp',
      alt: 'Veyro — player di allenamento con serie e ripetizioni e timer di recupero',
      width: 2160,
      height: 1440,
    },
    screens: [
      { src: '/images/veyro/screen-1.webp', alt: 'Importa la scheda del personal trainer da foto o PDF: gli esercizi vengono riconosciuti e li confermi tu' },
      { src: '/images/veyro/screen-2.webp', alt: "Genera la scheda con l'AI scegliendo obiettivo, giorni e attrezzatura" },
      { src: '/images/veyro/screen-3.webp', alt: 'Progressi: andamento del peso e gruppi muscolari allenati' },
      { src: '/images/veyro/screen-4.webp', alt: 'Allenamenti: programma attuale, statistiche e calendario dello storico' },
      { src: '/images/veyro/screen-5.webp', alt: 'Alimentazione: calorie e macro del piano alimentare' },
      { src: '/images/veyro/screen-6.webp', alt: 'Libreria esercizi filtrabile per gruppo muscolare, attrezzo e difficoltà' },
    ],
  },

  faq: [
    { q: 'Quanto costa Veyro?', a: "L'app è gratuita. L'abbonamento Pro costa €2,99 al mese e sblocca schede illimitate e analytics avanzati. I piani e il coaching dei personal trainer si acquistano a parte, al prezzo deciso dal trainer." },
    { q: 'Serve un personal trainer per usarla?', a: 'No. Puoi creare le tue schede dalla libreria di esercizi e i tuoi piani alimentari in autonomia; il marketplace serve a chi vuole essere seguito da un coach.' },
    { q: 'Su quali dispositivi funziona?', a: 'iOS e Android. Al momento è in beta test su TestFlight e Google Play Internal Testing.' },
    { q: 'Come si accede alla beta?', a: 'Scrivici dalla pagina Collabora: selezioniamo i primi tester e inviamo l\'invito per TestFlight o Internal Testing.' },
    { q: 'Sono un personal trainer: dove trovo gli strumenti per i coach?', a: "Nell'app dedicata, Veyro Trainer: builder di schede, gestione clienti, pacchetti in vendita e payout." },
  ],

  stats: [
    { icon: '🏋️', label: 'Esercizi in libreria', value: '800+', color: ACCENT },
    { icon: '💸', label: 'Al personal trainer', value: '85%', color: '#22d3ee' },
    { icon: '🍽️', label: 'Piani alimentari', value: '∞', color: '#a78bfa' },
  ],

  features: {
    title: 'Il fitness digitale, finalmente unito.',
    lead: "Niente più app separate per schede, calorie e coach. Veyro accorpa tutto in un'unica esperienza mobile, per chi si allena e per i personal trainer.",
    items: [
      {
        icon: '📋',
        title: 'Schede di Allenamento',
        desc: 'Segui la scheda del tuo PT o creane una da 800+ esercizi con video e istruzioni. Player con timer di recupero, registrazione serie, ripetizioni e carichi.',
      },
      {
        icon: '🤝',
        title: 'Marketplace Personal Trainer',
        desc: 'Personal trainer verificati, acquisto una tantum o coaching mensile con split payment automatico. Il PT riceve sempre l\'85%.',
      },
      {
        icon: '🥗',
        title: 'Piani Alimentari',
        desc: 'Costruttore di piani con libreria alimenti (Open Food Facts), calcolo calorie e macro per pasto e giornaliero, lista della spesa.',
      },
      {
        icon: '📈',
        title: 'Progressi',
        desc: 'Grafici di peso, misure, foto check-in e record personali sempre aggiornati.',
      },
      {
        icon: '📸',
        title: 'Importa la Scheda del PT',
        desc: 'Fotografa il foglio del tuo personal trainer o carica un PDF: gli esercizi vengono riconosciuti e agganciati al catalogo, e prima di salvare li confermi tu.',
      },
      {
        icon: '✨',
        title: "Scheda Generata dall'AI",
        desc: 'Obiettivo, giorni a settimana, durata e attrezzatura disponibile: Veyro propone un programma che puoi rivedere prima di salvarlo.',
      },
      {
        icon: '🔐',
        title: 'Login Social & Onboarding',
        desc: 'Wizard obiettivi e dati fisici, accesso rapido con Apple e Google.',
      },
      {
        icon: '💎',
        title: 'Free & Pro',
        desc: 'Modello freemium con abbonamento Pro a €2,99/mese: schede e piani alimentari illimitati, generazioni AI, analytics avanzati e 5% di sconto sul marketplace.',
      },
    ],
  },

  stack: ['React Native', 'Expo', 'TypeScript', 'Supabase', 'Stripe Connect', 'Reanimated 4'],

  cta: {
    eyebrow: '// in beta test',
    titleLead: 'Prova',
    titleAccent: 'Veyro.',
    text: 'Selezioniamo i primi tester per TestFlight (iOS) e Internal Testing (Android). Scrivici per partecipare alla beta.',
    to: '/collabora',
    label: 'Richiedi accesso',
  },
}

export default function Veyro() {
  return <ProductPage data={veyroData} />
}
